import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import {
  historyContentInnerSx,
  historyContentShellSx,
  historyPageRootSx,
} from '../../styles/historyStyles'
import {
  homeContentInnerSx,
  homeHeroGreetingSx,
  providerShellHeroShellSx,
  providerShellHeroSx,
} from '@/features/home/styles/homeStyles'

export function HistoryPageSkeleton() {
  return (
    <Box sx={historyPageRootSx} data-testid="history-page-skeleton" aria-busy aria-label="Loading history">
      <Box sx={providerShellHeroSx}>
        <Box sx={providerShellHeroShellSx}>
          <Box sx={homeContentInnerSx}>
            <Skeleton variant="text" width={220} height={48} sx={homeHeroGreetingSx} />
            <Skeleton variant="text" width={180} height={28} />
          </Box>
        </Box>
      </Box>

      <Box sx={historyContentShellSx}>
        <Box sx={historyContentInnerSx}>
          <Skeleton variant="text" width={140} height={40} sx={{ mt: { xs: 3, md: '25px' } }} />
          <Skeleton variant="text" width="60%" height={21} sx={{ mb: { xs: 3, md: '24px' } }} />
          {[0, 1, 2].map((key) => (
            <Skeleton
              key={key}
              variant="rounded"
              height={94}
              sx={{ borderRadius: '14px', mb: 1.25 }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
